import React from 'react'
import { useRouter } from 'next/router'
import { useMonitDomainStatus } from '@api/domain'
import Loader from './Loader'

function LoadingSection({ active, data }) {
  const { locale } = useRouter()

  const handleFinish = () => {
    window.location.href = `https://${data.domain}.blueassembly.com/admin/${locale}/login?token=${data.token}`
  }
  const domainStatusQuery = useMonitDomainStatus(data.domain, active)
  React.useEffect(() => {
    if (domainStatusQuery.data?.status === 'ready') handleFinish()
    return () => domainStatusQuery.remove()
  }, [domainStatusQuery.data])

  return <Loader active={active} />
}

export default LoadingSection
